export class PaymentReq {
    soId:number
    collection:number
}
export class PaymentTypeReq {
    tab:string;
    buyer?:number;
    

    constructor(
        tab:string,
    buyer?:number,
    
    ){
        this.buyer = buyer
        this.tab = tab
        
    }
}


export class CollectionsFilters {

    buyer?:string
    invNo?: string;

    constructor(
    buyer?:string,
    invNo?:string,
    ){
        this.buyer = buyer
        this.invNo = invNo
        
        
    }
}

